import { combineReducers } from 'redux';
import counterReducer from './counterSlice';
import inspectionSlice from './inspectionSlice';
import notificationsReducer from './notificationsSlice';
import realtimeReducer from './realtimeSlice';
import userSlice from './userSlice';
import uiVersionSlice from './uiVersionSlice';

export default combineReducers({
    counter: counterReducer,
    user: userSlice,
    inspection: inspectionSlice,
    // Fuera del whitelist de persistencia a propósito: ver `realtimeSlice`.
    realtime: realtimeReducer,
    notifications: notificationsReducer,
    uiVersion: uiVersionSlice
});
